import type { RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { systemLoader } from './system-loader';

export const systemRoutes: RouteObject = {
  loader: systemLoader,
  children: [
    {
      path: '/no-access',
      lazy: lazyComponent(() => import('@pages/shared/no-access-page'), 'NoAccessPage'),
    },
    {
      path: '*',
      lazy: lazyComponent(() => import('@pages/shared/not-found-page'), 'NotFoundPage'),
    },
  ],
};
